import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './SearchResults.scss';

import ResultList from './ResultList';
import Pagination from './Pagination';


const SearchResults = ({
    postsPerPage,
    searchKeywords,
    portal
}) => {

    const [posts, setPosts] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [postsLoaded, setPostsLoaded] = useState(false);
    const [filterOptions, setFilterOptions] = useState([]);
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [filterSections, setFilterSections] = useState([]);
    const [postsTotal, setFilterOptionsTotal] = useState([]);
    const [paginatedPosts, setPaginatedPosts] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [searchTextStore, setSearchTextStore] = useState("");
    const [sectionId, setSection] = useState(portal);
    const [filterID, setFilter] = useState(0);
    const [serviceId, setService] = useState(0);
    const [sortColumnField, setSortColumnField] = useState(0);

    useEffect(() => {
        if (!searchKeywords) return;
        getPosts(searchKeywords);

    }, [searchKeywords]);

    const getPosts = (keyword) => {
        setKeyword(keyword);
        setPostsLoaded(false);

        const res = async () => {
            const response = await fetch('/wp-json/wp/v2/search?search='+keyword+'&per_page=100&page=1')
            const data = await response.json();
            let loadedPosts = !!data ? data : [];

            loadedPosts.forEach((item, index) => {
                if(item.url.includes('guide')) item.category = "Guide";
                else if(item.subtype.includes('product')) item.category = "Produkt";
                else if(item.category.includes('news') || item.category.includes('Nyhet')) item.category = "Nyhet";
                else if(item.category.includes('education') || item.category.includes('Utbildning')) item.category = "Utbildning";
                else item.category = "Information";
            });

            setPosts(loadedPosts);
            setPostsLoaded(true);

            renderSection(loadedPosts);
            renderSectionFilters(sectionId, loadedPosts);

            let temp = filterPosts({
                filterID,
            }, sectionId, loadedPosts);

            setPageCount(Math.ceil(temp.length / postsPerPage));
            let filteredPostsTemp = temp.slice(offset, offset + postsPerPage);
            setPaginatedPosts(filteredPostsTemp);

            updateHistory(keyword);
        }

        // call the function
        res()
            // make sure to catch any error
            .catch(console.error);
    };

    const updateHistory = (keyword) => {
        const url = '/?s=' + keyword;
        const newState = "?s=" + keyword;
        // Make sure only to push state if it changes
        if (!_.isEqual(window.history.state, newState)) {
            window.history.pushState(newState, '', url);
        }
    }

    const renderSection = (unfilteredposts) => {
        setFilterSections([
            {
                title: 'Privat',
                sectionId: 'private',
                postAmount: unfilteredposts.filter(post => post.portal === 'private' || post.portal === 'global').length
            },
            {
                title: 'Företag',
                sectionId: 'company',
                postAmount: unfilteredposts.filter(post => post.portal === 'company' || post.portal === 'global').length
            }
        ])
    }

    const renderSectionFilters = (currSection, items) => {
        let filteredPostsTemp = items;

        let filterOptionsCompany = [
            {
                title: 'Allt',
                serviceId: 0,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global')).length
            },
            {
                title: 'Säkerhetsguider',
                serviceId: 1,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global') && post.url.includes('guide')).length
            },
            {
                title: 'Produkter',
                serviceId: 2,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global') && post.subtype === 'product').length
            },
            {
                title: 'Normer och regler',
                serviceId: 3,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global') && post.url.includes('ssf-normer')).length
            },
            {
                title: 'Utbildningar',
                serviceId: 4,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global') && (post.category.includes('education') || post.category.includes('Utbildning')) ).length
            },
            {
                title: 'Information',
                serviceId: 5,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'company' || post.portal === 'global') && !post.category.includes('education') && !post.category.includes('Utbildning') && !post.url.includes('ssf-normer') && post.subtype !== 'product' && !post.url.includes('guide')).length
            }
        ];

        let filterOptionsPrivate = [
            {
                title: 'Allt',
                serviceId: 0,
                postAmount: filteredPostsTemp.filter(post => post.portal === 'private' || post.portal === 'global').length
            },
            {
                title: 'Säkerhetsguider',
                serviceId: 1,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'private' || post.portal === 'global') && post.url.includes('guide')).length
            },
            {
                title: 'Produkter',
                serviceId: 2,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'private' || post.portal === 'global') && post.subtype === 'product').length
            },
            {
                title: 'Nyheter',
                serviceId: 3,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'private' || post.portal === 'global') && (post.category.includes('news') || post.category.includes('Nyhet'))).length
            },
            {
                title: 'Information',
                serviceId: 5,
                postAmount: filteredPostsTemp.filter(post => (post.portal === 'private' || post.portal === 'global') && post.subtype !== 'product' && !post.url.includes('guide') && !post.category.includes('news') && !post.category.includes('Nyhet')).length
            }
        ];
        if (currSection === 'private') setFilterOptions(filterOptionsPrivate);
        else setFilterOptions(filterOptionsCompany);

        filterPosts({
            filterID,
        }, currSection, posts);
    }

    const handlePaginationClick = (data) => {
        let o = data.selected * postsPerPage;
        setOffset(o);
        setPageNumber(data.selected);
        let filteredPostsTemp = filteredPosts.slice(data.selected * postsPerPage, (data.selected * postsPerPage) + postsPerPage);
        setPaginatedPosts(filteredPostsTemp);
        window.scrollTo(0, 0);
    };

    const handleTextSearch = (searchValue) => {
        setSearchTextStore(searchValue);
    };

    const handleTextSearchClick = (e) => {
        e.preventDefault();
        if (!searchTextStore) return;
        setOffset(0);
        setPageNumber(0);
        getPosts(searchTextStore);
    };

    const handleFilter = (filterIDIn) => {
        const isSelected = filterID === filterIDIn;

        if (isSelected) return;

        setOffset(0);
        setPageNumber(0);
        setFilter(filterIDIn);
        filterPosts({
            filterIDIn,
        }, sectionId, posts);
    };

    const handleSection = (sectionIdIn) => {
        const isSelected = sectionId === sectionIdIn;

        if (isSelected) return;


        setOffset(0);
        setPageNumber(0);
        setSection(sectionIdIn);
        setFilter(0);
        setService(0);

        renderSectionFilters(sectionIdIn, posts);
    };

    const handleSortColumn = sortColumnField => {
        setOffset(0);
        setPageNumber(0);
        setSortColumnField(sortColumnField);
    };

    const filterPosts = (filters, currSectionHere, posts) => {
        const {
            filterIDIn,
        } = filters;

        let sectionIdCurr = currSectionHere;

        let filteredPostsTemp = posts;

        setFilterOptionsTotal(posts.length);
        if (sectionIdCurr && sectionIdCurr !== 0) {
            filteredPostsTemp = filteredPostsTemp.filter(post => post.portal === sectionIdCurr || post.portal === 'global');
        }

        if (filterIDIn && filterIDIn !== 0) {
            if (filterIDIn === 1) {
                //Guides
                filteredPostsTemp = filteredPostsTemp.filter(post => post.url.includes('guide'))
            } else if (filterIDIn === 2) {
                //Products
                filteredPostsTemp = filteredPostsTemp.filter(post => post.subtype === 'product')
            } else if (filterIDIn === 3) {
                if(sectionIdCurr === 'private') {
                    //News
                    filteredPostsTemp = filteredPostsTemp.filter(post => post.category.includes('news') || post.category.includes('Nyhet'))
                } else {
                    filteredPostsTemp = filteredPostsTemp.filter(post => post.url.includes('ssf-normer'))
                }
            } else if (filterIDIn === 4) {
                //Education
                filteredPostsTemp = filteredPostsTemp.filter(post => post.category.includes('education') || post.category.includes('Utbildning'))
            } else if (filterIDIn === 5) {
                //Information / misc
                if (sectionIdCurr === 'private') filteredPostsTemp = filteredPostsTemp.filter(post => post.subtype !== 'product' && !post.url.includes('guide') && !post.category.includes('news') && !post.category.includes('Nyhet'))
                else filteredPostsTemp = filteredPostsTemp.filter(post => !post.category.includes('education') && !post.category.includes('Utbildning') && !post.url.includes('ssf-normer') && post.subtype !== 'product' && !post.url.includes('guide'))
            }
        }

        setFilteredPosts(filteredPostsTemp);

        setPageCount(Math.ceil(filteredPostsTemp.length / postsPerPage));

        let filteredPostsPaginated = filteredPostsTemp.slice(offset, offset + postsPerPage);

        setPaginatedPosts(filteredPostsPaginated);

        return filteredPostsTemp;
    };

    const sortColumn = (sortColumnField, posts) => (
        [...posts].sort((a, b) => {
            let first = sortColumnField && a[sortColumnField].toLowerCase();
            let second = sortColumnField && b[sortColumnField].toLowerCase();

            return first.localeCompare(second);
        })
    )

    return (
        <div className="Search">
            <div className="Search__Wrapper">
                <h1 className="Search__Title">Sök på hemsidan</h1>

                <div className="Search__Container">
                    <form className="Search__Search-Text" onSubmit={handleTextSearchClick}>
                        <input
                            className="Search__Search-Text-Input"
                            id="searchInput"
                            type="text"
                            defaultValue={keyword}
                            onChange={(e) => handleTextSearch(e.currentTarget.value)}
                        />
                        <button
                            type="submit"
                            className="Search__Button"
                        ><span className="sr-only">Sök</span></button>
                    </form>
                    <div className="Search__Options">
                        <div className="Search__Option">
                            <div className="Search__Sections">
                                {filterSections && filterSections.map((option, index) =>
                                    <label className="Search__Filter-Label" key={index}>
                                        <input
                                            className="Search__Filter-Input"
                                            type="radio"
                                            name="section"
                                            value={option.title}
                                            checked={sectionId === option.sectionId}
                                            onChange={() => handleSection(option.sectionId)}
                                        />{option.title} <span
                                        className="Search__Filter-Input--Result">({option.postAmount})</span>
                                        <span className="Search__Filter-Span">
                                                    {option.title} <span
                                            className="Search__Filter-Input--Result">({option.postAmount})</span>
                                                </span>
                                    </label>
                                )}
                            </div>

                        </div>

                    </div>
                </div>

                <div className="Search__Filter">
                    {filterOptions && !!postsLoaded && filterOptions.map((option, index) =>
                        <label className="Search__Tab-Label" key={index}>
                            <input
                                className="Search__Tab-Input"
                                type="radio"
                                name="filter"
                                value={option.title}
                                checked={filterID === option.serviceId}
                                onChange={() => handleFilter(option.serviceId)}
                            /><span className="Search__Tab-Title">{option.title}</span> <span className="Search__Tab-Input--Result">({option.postAmount})</span>
                            <div className="Search__Tab-Span">
                                <span>{option.title}</span> <span
                                className="Search__Tab--Result">({option.postAmount})</span>
                                </div>
                        </label>
                    )}
                </div>
                {!!postsTotal && postsTotal >= 0 && postsTotal != '' && !!keyword && !!postsLoaded &&
                    <div className="Search__Count">Din sökning
                        på <span>"{keyword}"</span> gav {postsTotal} träffar på allt</div>
                }

                { !postsLoaded && !!keyword &&
                    <div className="Search__Loader">

                    </div>
                }

                {!!paginatedPosts && paginatedPosts.length > 0 && !!postsLoaded &&
                    <ResultList
                        posts={paginatedPosts}
                        onSort={() => handleSortColumn()}
                    />
                }

                {!!paginatedPosts && paginatedPosts.length === 0 && !!postsLoaded &&
                    <div className="Search__NoResults">
                        <h3 className="Search__NoResults__Title">Din sökning på <span>{keyword}</span> gav tyvärr inga resultat.</h3>
                        <p  className="Search__NoResults__Text">Dubbelkolla om du råkat stava fel eller testa att ange ett annat sökord.</p>
                    </div>
                }

                {!!pageCount && pageCount > 1 && !!postsLoaded &&
                    <Pagination
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        onPageChangeClick={handlePaginationClick}
                    />
                }
            </div>
        </div>
    )
}


SearchResults.propTypes = {
    posts: PropTypes.array,
    offset: PropTypes.number,
    searchText: PropTypes.array,
    filterID: PropTypes.number,
    sectionId: PropTypes.string,
    sortColumnField: PropTypes.string,
    pageNumber: PropTypes.number,
};

SearchResults.defaultProps = {
    postsPerPage: 10,
    searchKeywords: '',
    portal: '',
    posts: [],
    offset: 0,
    searchText: [],
    filterID: 0,
    sectionId: "private",
    sortColumnField: '',
    pageNumber: 0
};

export default SearchResults;